import {all, call, fork, put, takeLatest} from "redux-saga/effects";
import * as actions from "../../actions/actions";
import {history} from "../../../api/fileApi"
import {push} from "connected-react-router";

export default function* FileHistory() {
    yield all([
        fork(watchFetchFileHistoryRequest),
    ]);
}

function* watchFetchFileHistoryRequest() {
    yield takeLatest(
        actions.FETCH_FILE_HISTORY_REQUEST,
        FetchFileHistoryRequest
    )
}

function* FetchFileHistoryRequest(fileData) {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(history, fileData.value.bankId,fileData.value.file )
        yield put({ type: actions.FETCH_FILE_HISTORY_SUCCESS, history: data })
        yield put(push(`/file/${fileData.value.file}/history`))
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_FILE_HISTORY_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
        }
    }
}